// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminProcedure_container__2c5Nr","text":"AdminProcedure_text__1MmnZ","schedules":"AdminProcedure_schedules__3yFhC"};